import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Divider from '@mui/material/Divider';

import PushImage from './PushImage.jsx';
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: "50vw",
  bgcolor: '#242424',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function BasicModal() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Button onClick={handleOpen} style={{ color: "lightgray", background: "none", border: "1px solid rgb(187 146 35)", padding: "10px 20px" }}>
        <ArrowCircleUpIcon fontSize='small' style={{ marginRight: "0.6rem" }} />
        Push Image</Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2" style={{ color: "lightgray", fontWeight: "900" }}>
            Push Image
          </Typography>
          <Divider sx={{ backgroundColor: 'lightgray', margin: "2rem 0" }} />
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <PushImage />
            {/* <InputImage chip_label="AWS" text_label="Readonly input here" button_text="upload file" />
            <InputImage chip_label="Docker Hub" text_label="Readonly input here" button_text="upload file" /> */}
          </Typography>
        </Box>
      </Modal>
    </div>
  );
}
